<script>
    import Nav from '../components/Nav.svelte'
    import Notebook from '../components/Notebook.svelte'
    import NotebookControls from '../components/NotebookControls.svelte'
    import NotebookTree from '../components/NotebookTree.svelte'
    import Entry from '../components/Entry.svelte'
    import References from '../components/References.svelte'
    import EntryTree from '../components/EntryTree.svelte'

    import { Notebook as NotebookController } from '../controller.js'
	export let id;
    export let selected_entry_id = 0;
    $: selected_entry = notebook.entries[selected_entry_id];

    let notebook = NotebookController.load(id)

    function on_link_click(clicked_entry_id) {
        selected_entry_id = clicked_entry_id;

        const url = new URL(window.location)
        let new_url = `${url.origin}/notebook/${id}/${selected_entry_id}`
        history.pushState({}, '', new_url)
    }

    function do_delete() {
        if(confirm("Are you sure? Deleting an entry cannot be undone")) {
            notebook.delete_entry(selected_entry.id)
            notebook.save()
            notebook = NotebookController.load(id)
            selected_entry_id = 0;
        }
    }

</script>


<Nav notebook_id={id} />

<h1>{notebook.name}</h1>
<div id="container">
    <div id="entry-tree">
        <EntryTree notebook={notebook} callback={on_link_click} />
    </div>

    <div id="entry">
        {#if selected_entry != null}
        <Entry
            notebook={notebook}
            entry={selected_entry}
            callback={on_link_click}
        />
        {/if}
    </div>

    <div id="controls">
        {#if selected_entry != null}
        <a href="/notebook/{notebook.id}/{selected_entry.id}/edit"><button>Edit</button></a>
        <button on:click={do_delete}>Delete</button>
        <br>
        <References
            notebook={notebook}
            entry={selected_entry}
            callback={on_link_click}
        />
        {/if}
    </div>
</div>


<style>
#container {
    display: grid;
    grid-template-columns: 250px auto 250px;
    max-width: 1200px;
    text-align: center;
    margin-left: auto;
    margin-right: auto;
    max-height: 100%;
    position: relative;
}
#entry-tree {
    text-align: left;
    max-width: 250px;
    margin-right: 20px;
    overflow: auto;
    padding-right: 20px;
}
#entry {
    margin-bottom: 20px;
    overflow: auto;
}
</style>
